// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"registration_wrapper__oYKXy","registration":"registration_registration__dyVnf","registration_title":"registration_registration_title__Ks6KX"};